export default __webpack_public_path__ + "static/media/P30001.b33c6056.png";